import * as React from "react";
const SvgSideArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 14, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M.65 1.65L2.06.23l6.7 6.7-6.7 6.72-1.41-1.42 5.29-5.3-5.3-5.28z", fill: "#333" }));
export default SvgSideArrow;
